// feat_347 — Tab "Clasificación" de /Settings.
//
// 🔴 REGLA #1 DE ESTA PANTALLA: los 8 TabPanel quedan SIEMPRE MONTADOS (el shell
// los oculta con `hidden`, nunca los desmonta). 21 campos de texto guardan con
// `onBlur`; si al cambiar de tab React desmontara el input, el onBlur NO dispara
// y el usuario pierde lo tipeado sin ningún aviso. NO convertir esto en render
// condicional ni en lazy.
//
// Todo el estado vive en el padre (`Settings/index.js`) y llega por `ctx`.
// El JSX es un MOVIMIENTO VERBATIM de index.js — Fase 1 no cambia ni un pixel.
//
// ⚠ <ContactTypeModal> NO se monta acá: sigue montado en index.js FUERA del
// <Container>, y sigue recibiendo signatureFeatureEnabled={signatureEnabled}
// (estado que vive en el tab Mensajes). Ese cruce entre tabs es exactamente lo
// que resuelve el ctx del padre.
import React from "react";

import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Chip from "@material-ui/core/Chip";

import { i18n } from "../../../translate/i18n.js";

const TabClasificacion = ({ ctx }) => {
	const {
		classes,
		contactTypes,
		ctForm, setCtForm,
		handleCreateContactType,
		handleDeleteContactType,
		setEditingContactType,
		setTypeModalOpen,
		contactReasons,
		crForm, setCrForm,
		handleCreateContactReason,
		handleDeleteContactReason,
	} = ctx;

	return (
		<>
			{/* Tipos de Cliente section */}
			<Typography variant="body2" className={classes.sectionTitle} gutterBottom>
				{i18n.t("settingsExtra.tiposCliente")}
			</Typography>
			<Paper className={classes.paper} style={{ flexDirection: "column", alignItems: "flex-start", gap: 8 }}>
				<div style={{ display: "flex", gap: 8, alignItems: "center", width: "100%" }}>
					<TextField
						size="small"
						label={i18n.t("settingsExtra.nombreTipo")}
						value={ctForm.name}
						onChange={e => setCtForm({ ...ctForm, name: e.target.value })}
						style={{ flex: 1 }}
					/>
					<input
						type="color"
						value={ctForm.color}
						onChange={e => setCtForm({ ...ctForm, color: e.target.value })}
						style={{ width: 36, height: 36, border: "none", cursor: "pointer", borderRadius: 4 }}
					/>
					<Button size="small" variant="contained" color="primary" onClick={handleCreateContactType} disabled={!ctForm.name.trim()}>
						{i18n.t("settingsExtra.agregar")}
					</Button>
				</div>
				<div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginTop: 4 }}>
					{contactTypes.map(ct => (
						<Chip
							key={ct.id}
							label={ct.name}
							size="small"
							style={{ backgroundColor: ct.color, color: "#fff", cursor: "pointer" }}
							onClick={() => { setEditingContactType(ct); setTypeModalOpen(true); }}
							onDelete={() => handleDeleteContactType(ct.id)}
						/>
					))}
					{contactTypes.length === 0 && (
						<Typography variant="caption" color="textSecondary">{i18n.t("settingsExtra.sinTipos")}</Typography>
					)}
				</div>
			</Paper>

			{/* Motivos de Contacto */}
			<Typography variant="body2" className={classes.sectionTitle} gutterBottom>
				{i18n.t("settingsExtra.motivosContacto")}
			</Typography>
			<Paper className={classes.paper} style={{ flexDirection: "column", alignItems: "flex-start", gap: 8 }}>
				<div style={{ display: "flex", gap: 8, alignItems: "center", width: "100%" }}>
					<TextField
						size="small"
						label={i18n.t("settingsExtra.nombreMotivo")}
						value={crForm.name}
						onChange={e => setCrForm({ name: e.target.value })}
						style={{ flex: 1 }}
					/>
					<Button size="small" variant="contained" color="primary" onClick={handleCreateContactReason} disabled={!crForm.name.trim()}>
						{i18n.t("settingsExtra.agregar")}
					</Button>
				</div>
				<div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginTop: 4 }}>
					{contactReasons.map(r => (
						<Chip key={r.id} label={r.name} size="small" onDelete={() => handleDeleteContactReason(r.id)} />
					))}
					{contactReasons.length === 0 && (
						<Typography variant="caption" color="textSecondary">{i18n.t("settingsExtra.sinMotivos")}</Typography>
					)}
				</div>
			</Paper>
		</>
	);
};

export default TabClasificacion;
